import { BaseController } from '../../common/base/controller';
import { ticketStateName } from '../ticket/ticket.state';
import { homeStateName } from '../home/home.state';

export class LoginByTokenController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({
      controllerService,
    });
  }

  $onInit() {
    const { token, ticketId } = this.$stateParams;

    this.userService.login(token);
    if (ticketId) {
      this.go(ticketStateName, { ticketId });
    } else {
      this.go(homeStateName);
    }
  }
}
